import {
  Avatar,
  Divider,
  ListItemAvatar,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import cdnService from "../../../services/cdnService";
import {
  getPreFieldTitleDesc,
  getPreFieldValueDesc,
  getTypoStyle,
  ListItemWrapper,
} from "../_base/StyledComponent";
import readFieldValue from "../_base/readFieldValue";
import FieldRenderBlockBaseProp from "../_base/FieldRenderBlockBaseProp";

export interface GoogleReviewType {
  title?: string;
  subTitle?: string;
  url: string;
}
export default function GoogleReviewBlock(props: FieldRenderBlockBaseProp) {
  const theme = useTheme();
 
  const fieldValue = readFieldValue(props.field, { url: '', title: '', subTitle: '' });
  return (
    <>
      <ListItemWrapper
        onClick={() => {
          
            window.open(fieldValue.url);
          
        }}
        sx={{
          minWidth: 0,
          "&:hover": {
            cursor: "pointer",
          },
        }}
      >
        <ListItemAvatar
          sx={{
            mr: 1,
            display: "flex",
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              background: `${theme.colors.alpha.white[10]}`,
              color: `${theme.colors.gradients.pink2}`,
              width: 64,
              height: 64,
            }}
          >
            <img src={cdnService.toCdnUrl("google.png", "icons")} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          sx={{
            color: `${theme.colors.alpha.black[70]}`,
          }}
          primary={
            <Typography
              gutterBottom
              variant="h4"
              style={getTypoStyle(props.themeColor)}
            >
              {fieldValue.title || 'Google Review'}
            </Typography>
          }
          secondary={
            fieldValue.subTitle ? <Typography
            sx={{
              color: `${theme.colors.alpha.black[70]}`,
            }}
            variant="subtitle2"
            style={getTypoStyle(props.themeColor)}
          >
            {fieldValue.subTitle}
          </Typography> : null
          }
        />
      </ListItemWrapper>
      <Divider />
    </>
  );
}
